import { ReactComponent as CloseIconThinSVG } from '@/assets/icons/CloseIconThin.svg';
import { SVGProps } from 'react';

const CloseIconThin = (props: SVGProps<SVGSVGElement>) => <CloseIconThinSVG {...props} />;

export default CloseIconThin;
